export default "__VITE_ASSET__328ce665__$_?component__"